import { Divider } from '@mui/material';

export const CustomDivider = () => {
  return (
    <Divider
      aria-hidden='true'
      sx={{
        height: '3px',
        width: '50px',
        backgroundColor: 'primary.shade_400',
      }}
    />
  );
};
